import routeIdsRaw from '@/content/dictionary-seo/route-ids.json' assert { type: 'json' }
import {
  generateDictionarySlug,
  getDictionaryEntryPath,
  type DictionarySlugEntry
} from '@/lib/dictionary-slugs'

const routeIds = new Set(routeIdsRaw as number[])

export function hasStaticDictionaryRoute(
  entryOrId: DictionarySlugEntry | number
) {
  return routeIds.has(typeof entryOrId === 'number' ? entryOrId : entryOrId.id)
}

export function getDictionaryLookupPath(
  entry: Pick<DictionarySlugEntry, 'id'>
) {
  return `/dict?id=${entry.id}`
}

export function getIndexedDictionaryEntryPath(entry: DictionarySlugEntry) {
  return hasStaticDictionaryRoute(entry)
    ? getDictionaryEntryPath(entry)
    : getDictionaryLookupPath(entry)
}

export function getIndexedDictionaryEntrySlug(entry: DictionarySlugEntry) {
  return hasStaticDictionaryRoute(entry) ? generateDictionarySlug(entry) : null
}
